module.exports = __webpack_public_path__ + "img/banner2.c60f1f0d.png";